// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

export class Slider {
  async init() {
    const swiper = new Swiper('.swiper-home', {
      // Optional parameters
      loop: true,
      speed: 800,
      effect: 'fade',
     autoplay: {delay: 5000,},
    
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        type: "progressbar",
      },
    
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    
      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },

    });
  }
}
